module.exports = __webpack_public_path__ + "media/images/icons/rain-836c4ee20840a4c856588f811acae91f.svg";